<script setup>
import { RouterLink, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { House, Tags, User } from 'lucide-vue-next'

const { t } = useI18n()
const route = useRoute()

const ITEMS = [
  { to: '/', icon: House, key: 'home' },
  // Was '/goals', which rendered the home screen a second time -- a whole tab spent on a
  // duplicate. The categories manager has nowhere else to live.
  { to: '/categories', icon: Tags, key: 'categories' },
  { to: '/profile', icon: User, key: 'profile' },
]
</script>

<template>
  <!-- /login and /signup are the only routes marked `meta.public` (see router/index.js) —
       reusing that flag instead of a hardcoded path list keeps this in lockstep with the
       route table if a public route is ever renamed or added. -->
  <!--
    `bg-cream/95` + `backdrop-blur`: a translucent bar so content scrolling underneath stays
    faintly visible. This briefly shipped opaque, because `cream` was one of two tokens still
    mapped to a bare `var()` and Tailwind drops an alpha-modified utility on such a colour
    silently — no error, no rule. The whole palette now uses the rgb()/<alpha-value> form and
    tokens.test.js asserts that property across every colour rather than by name.
  -->
  <nav
    v-if="!route.meta.public"
    class="fixed inset-x-0 bottom-0 z-40 border-t border-sand bg-cream/95 backdrop-blur"
    :aria-label="t('nav.label')"
  >
    <ul class="mx-auto flex max-w-content items-center justify-around px-6 py-3">
      <li
        v-for="item in ITEMS"
        :key="item.key"
      >
        <RouterLink
          :data-testid="`nav-${item.key}`"
          :to="item.to"
          class="grid place-items-center p-2"
          :class="route.path === item.to ? 'text-terracotta' : 'text-ink-muted'"
          :aria-current="route.path === item.to ? 'page' : undefined"
          :aria-label="t(`nav.${item.key}`)"
        >
          <component
            :is="item.icon"
            class="size-6"
            aria-hidden="true"
          />
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>
